export default {
  state: {
    dataSource: ""
  },
  mutations: {
    setDataSource(state, value) {
      state.dataSource = value;
    }
  }
}